import { defineStore } from 'pinia'
import apiClient, { authAPI } from '@/api/apiClient'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token:
      localStorage.getItem('token') || sessionStorage.getItem('token') || null,
    user: null,
    branch_name: null,
    sessions: [],
  }),

  getters: {
    // 인증 상태 확인 getter 추가
    isAuthenticated: state => {
      return !!state.token && !!state.user
    },
  },

  actions: {
    setUser(userData) {
      this.user = userData
      this.branch_name = userData.branch_name
    },

    clearUser() {
      this.user = null
      this.branch_name = null
      this.sessions = []
      this.token = null
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      delete apiClient.defaults.headers.common['Authorization']

      // 현재 URL이 로그인 페이지가 아닌 경우에만 리다이렉트
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    },

    // 사용자 정보 가져오기
    async getUserInfo() {
      try {
        const response = await apiClient.get('/auth/user')
        this.setUser(response.data)
        return response.data
      } catch (error) {
        console.error('사용자 정보 로딩 실패:', error)
        throw error
      }
    },

    async logout() {
      try {
        await authAPI.logout()
        localStorage.removeItem('token')
        this.clearUser()
        delete apiClient.defaults.headers.common['Authorization']
      } catch (error) {
        console.error('로그아웃 실패:', error)
        this.clearUser()
        localStorage.removeItem('token')
      }
    },

    async fetchSessions() {
      try {
        const response = await authAPI.getSessions()
        if (response.data.success) {
          this.sessions = response.data.data
        }
      } catch (error) {
        // 인증 관련 에러인 경우
        if (error?.response?.status === 401 || error?.code === 100) {
          this.clearUser()
        }
        throw error
      }
    },

    async logoutSession(token) {
      try {
        console.log('세션 로그아웃 시도:', token)

        // 현재 사용 중인 토큰인지 먼저 확인
        const currentToken =
          localStorage.getItem('token') || sessionStorage.getItem('token')
        const isCurrentSession = token === currentToken

        const result = await authAPI.deleteSession(token)
        console.log('세션 삭제 응답:', result)

        if (isCurrentSession) {
          // 현재 세션이면 바로 로그아웃 처리
          console.log('현재 사용 중인 세션이 삭제됨')
          this.clearUser() // 간단한 정리만 수행
          window.location.href = '/login'
          return
        }

        // 다른 세션인 경우에만 목록 갱신
        await this.fetchSessions()
      } catch (error) {
        console.error('세션 로그아웃 실패:', error)
        throw error
      }
    },

    async checkAuth() {
      if (!this.token) {
        this.clearUser()
        return false
      }

      try {
        await this.getUserInfo()
        return true
      } catch (error) {
        console.error('인증 확인 실패:', error)
        this.clearUser()
        return false
      }
    },
  },

  persist: true, // 페이지 새로고침해도 상태 유지
})
